import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import appRoutes from '../../../../../../../../../routes/appRoutes';
import CashbackPresenter from '../../../../../../../../../presenters/CashbackPresenter';

import Actions from './components/Actions';

const CashbackCellView = (props) => {
  const { cashback } = props;

  const transactionLink = CashbackPresenter.hasPlaidTransaction(cashback)
    ? appRoutes.transactionPath(CashbackPresenter.plaidTransactionId(cashback))
    : '#';
  return (
    <tbody>
      <tr>
        <td>{CashbackPresenter.date(cashback)}</td>
        <td>{CashbackPresenter.name(cashback)}</td>
        <td>{CashbackPresenter.rateReadable(cashback)}</td>
        <td>{CashbackPresenter.amountReadable(cashback)}</td>
        <td>{CashbackPresenter.sourceReadable(cashback)}</td>
        <td>
          <div>{CashbackPresenter.state(cashback)}</div>
          {CashbackPresenter.isQuarantined(cashback) && (
            <div>{`reason: ${CashbackPresenter.quarantinedReasonReadable(
              cashback
            )}`}</div>
          )}
        </td>
        <td>
          {CashbackPresenter.hasPlaidTransaction(cashback) ? (
            <a href={transactionLink} target="_blank">
              {CashbackPresenter.transactionAmountReadable(cashback)}
            </a>
          ) : (
            CashbackPresenter.transactionAmountReadable(cashback)
          )}
        </td>
        <Actions {...props} />
      </tr>
    </tbody>
  );
};

export default createFragmentContainer(CashbackCellView, {
  cashback: graphql`
    fragment CashbackCell_cashback on Cashback {
      id
      date
      name
      rate
      place
      storeId
      amount
      source
      plaidTransactionId
      transactionAmount
      state
      quarantinedReason
      availableStates
    }
  `,
});

CashbackCellView.propTypes = {
  cashback: CashbackPresenter.shape().isRequired,
};
